import React, { Component } from 'react'
import '../styles/PersonalInformation.css'
import DropdownWidget from '../widgets/DropdownWidget'
import APIGenericRequest from '../api/APIGenericRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'
import SwitchWidget from '../widgets/SwitchWidget'
import ActivityIndicator from '../widgets/ActivityIndicator'
import DatePicker from '../widgets/DatePicker'

class PersonalInformation extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			onItemSelected: props.onItemSelected,
			age: 0,
			classification : "-- SELECT --",
			subClassification: "-- SELECT --",
			cs: "-- SELECT --",
			sc: "-- SELECT --",
			educ: "-- SELECT --",
			sexCode: "-- SELECT --",
			ruralWoman: "-- SELECT --",
			ext: "EXT",
			regionPlaceholder: "REGION",
			provincePlaceholder: "PROVINCE",
			cityPlaceholder: "CITY/MUNICIPALITY",
			brgyPlaceholder: "BARANGAY",
			dateToday: props.dateToday,
		}
		this.getFarmerInfo = this.getFarmerInfo.bind(this)
		this.setAllFieldsDisabled = this.setAllFieldsDisabled.bind(this)
		this.getAllProvincesByRegionId = this.getAllProvincesByRegionId.bind(this)
		this.getAllCitiesByProvinceId = this.getAllCitiesByProvinceId.bind(this)
		this.getAllBarangaysByCityId = this.getAllBarangaysByCityId.bind(this)
		this.setDisplayCategory = this.setDisplayCategory.bind(this)
	}

	getFarmerInfo() {
		this.setState({showActivityIndicator: true})
		const farmer = APIFarmerRequest.getFarmerDetailsById(this.state.accessToken, parseInt(this.props.farmerID))
		farmer.then((response) => {
			const classifications = APIFarmerRequest.getRegistrantClassificationById(this.state.accessToken, response.results.farmerRegistration.classification_id)
			classifications.then((rc) => {
				this.setState({classification: rc.results.name})
			})
			const subClass = APIFarmerRequest.getFarmerCategoryById(this.state.accessToken, response.results.farmerRegistration.category_id)
			subClass.then((rc) => {
				this.setState({subClassification: rc.results.name})
			})
			const civilStat = APIGenericRequest.getCivilStatusById(this.state.accessToken, response.results.farmerRegistration.civil_status_id)
			civilStat.then((rc) => {
				this.setState({cs: rc.results.name})
			})
			const sex = APIGenericRequest.getAllSex(this.state.accessToken)
			sex.then((rc) => {
				for(const v of rc.results.rows) {
					if(v.sex_code === response.results.farmerBasicInfo.sex_code) {
						this.setState({sc: v.name})
					}
				}
			})
			const educ = APIGenericRequest.getEducationLevelById(this.state.accessToken, response.results.farmerRegistration.education_id)
			educ.then((rc) => {
				this.setState({educ: rc.results.name})
			})
			if(response.results.farmerHomeAddress != null) {
				const region = APIGenericRequest.getRegionById(this.state.accessToken, response.results.farmerHomeAddress.region_id)
				region.then((rc) => {
					this.setState({regionPlaceholder: rc.results.name})
				})
				const province = APIGenericRequest.getProvinceById(this.state.accessToken, response.results.farmerHomeAddress.province_id)
				province.then((rc) => {
					this.setState({provincePlaceholder: rc.results.name})
				})
				const city = APIGenericRequest.getCityById(this.state.accessToken, response.results.farmerHomeAddress.city_id)
				city.then((rc) => {
					this.setState({cityPlaceholder: rc.results.name})
				})
				const barangay = APIGenericRequest.getBarangayById(this.state.accessToken, response.results.farmerHomeAddress.barangay_id)
				barangay.then((rc) => {
					this.setState({brgyPlaceholder: rc.results.name})
				})
			}
			if(response.results.farmerBasicInfo.sex_code == "F") {
				const circ = APIFarmerRequest.getCircumstanceById(this.state.accessToken, response.results.farmerRegistration.rural_women_circumstance_id)
				circ.then((rc) => {
					this.setState({
						ruralWoman: rc.results.name,
						circumstance_id: rc.results.circumstance_id,
					})
				})
			}
			if(response.results.farmerRegistration.registration_date != null) {
				const d1 = new Date(response.results.farmerRegistration.registration_date)
				const rm = (d1.getMonth()<10)? "0"+(d1.getMonth()+1): d1.getMonth()+1
				const rd = (d1.getDate()<10)? "0"+d1.getDate(): d1.getDate()
				var d2 = new Date(response.results.farmerBasicInfo.birth_date)
				var m = (d2.getMonth()<10)? "0"+(d2.getMonth()+1): d2.getMonth()+1
				var d = (d2.getDate()<10)? "0"+d2.getDate(): d2.getDate()
				var regDate = d1.getFullYear() + "-" + rm + "-" + rd
				var bDate = d2.getFullYear() + "-" + m + "-" + d
				var bd = new Date(bDate)
			}
			const now = new Date()
			let yAge = 0
			if (bd?.getYear() < now.getYear()) {
				yAge = now.getYear() - bd.getYear()
				if (bd.getMonth() < now.getMonth()) {
					yAge = yAge
				} else if (bd.getMonth() === now.getMonth()) {
					if(bd.getDate() <= now.getDate()) {
						yAge = yAge
					} else yAge = yAge - 1
				} else yAge = yAge - 1
			} else yAge = 0
			this.setState({
				dateRegistered: (regDate != null)? regDate: null,
				registrationNo: response.results.farmerRegistration.registration_no,
				firstName: response.results.farmerBasicInfo.first_name,
				middleName: response.results.farmerBasicInfo.middle_name,
				lastName: response.results.farmerBasicInfo.last_name,
				ext: (response.results.farmerBasicInfo.extension_name === null)? "N/A":response.results.farmerBasicInfo.extension_name,
				inRSBA: response.results.farmerRegistration.in_rsbsa_list,
				birthDate: bDate,
				age: yAge,
				contactNo: response.results.farmerRegistration.contact_no,
				didGrad: response.results.farmerRegistration.did_graduate,
				arbID: response.results.farmerRegistration.arb_id,
				showActivityIndicator: false
			})
			if(this.props.view === "view-details") {
				this.setAllFieldsDisabled(true)
			}
			else {
				this.setAllFieldsDisabled(false)
				if(response.results.farmerHomeAddress != undefined) {
					this.getAllProvincesByRegionId(response.results.farmerHomeAddress.region_id)
					this.getAllCitiesByProvinceId(response.results.farmerHomeAddress.province_id)
					this.getAllBarangaysByCityId(response.results.farmerHomeAddress.city_id)
				}
			}
		})
	}

	setAllFieldsDisabled(v) {
		const fields = document.querySelectorAll('.personal-information *')
		for(const f of fields) {
			f.disabled = v
		}
	}

	componentDidUpdate(prevProps) {
		if(this.state.didGraduate == null) {
			const g = []
			g.push({id: 0, name: "NO"})
			g.push({id: 1, name: "YES"})
			this.setState({didGraduate: g})
		}
	}

	componentWillMount() {
		if(this.props.farmerID != null) {
			this.getFarmerInfo()
			if(this.props.view === "view-details") {
				return
			}
		}
		const classifications = APIFarmerRequest.getAllRegistrantClassifications(this.state.accessToken)
		classifications.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.classification_id, name: v.name})
			}
			this.setState({classifications: c})
		})
		const categories = APIFarmerRequest.getAllFarmerCategory(this.state.accessToken)
		categories.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({categoryId: v.category_id, name: v.name, classificationId: v.classification_id })
			}
			this.setState({category: c})
		})
		const civilStatus = APIGenericRequest.getAllCivilStatus(this.state.accessToken)
		civilStatus.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.civil_status_id, name: v.name})
			}
			this.setState({civilStatus: c})
		})
		const educ = APIGenericRequest.getAllEducationLevels(this.state.accessToken)
		educ.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.education_id, name: v.name})
			}
			this.setState({educationLevels: c})
		})
		const sex = APIGenericRequest.getAllSex(this.state.accessToken)
		sex.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.sex_id, name: v.name})
			}
			this.setState({sex: c})
		})
		const circ = APIFarmerRequest.getAllCircumstances(this.state.accessToken)
		circ.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.circumstance_id, name: v.name})
			}
			this.setState({circumstances: c})
		})
		const region = APIGenericRequest.getAllRegions(this.state.accessToken)
		region.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.region_id, name: v.name})
			}
			this.setState({regions: c})
		})
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken)
		ext.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name})
			}
			c.push({id: 0, name: "N/A"})
			c.sort((a, b) => (a.id > b.id) ? 1 : -1)
			this.setState({extName: c})
		})
	}

	getAllProvincesByRegionId(id, reset) {
		const province = APIGenericRequest.getAllProvincesByRegionId(this.state.accessToken, id)
		province.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.province_id, name: v.name})
			}
			if(reset) {
				this.setState({
					provinces: c,
					provincePlaceholder: "PROVINCE",
					cityPlaceholder: "CITY/MUNICIPALITY",
					brgyPlaceholder: "BARANGAY"
				})
			}
			else {
				this.setState({provinces: c})
			}
		})
	}

	getAllCitiesByProvinceId(id, reset) {
		const city = APIGenericRequest.getAllCitiesByProvinceId(this.state.accessToken, id)
		city.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.city_id, name: v.name})
			}
			if(reset) {
				this.setState({
					cities: c,
					cityPlaceholder: "CITY/MUNICIPALITY",
					brgyPlaceholder: "BARANGAY"
				})
			}
			else {
				this.setState({cities: c})
			}
		})
	}

	getAllBarangaysByCityId(id, reset) {
		const city = APIGenericRequest.getAllBarangaysByCityId(this.state.accessToken, id)
		city.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.barangay_id, name: v.name})
			}
			if(reset) {
				this.setState({
					barangays: c,
					brgyPlaceholder: "BARANGAY"
				})
			}
			else {
				this.setState({barangays: c})
			}
		})
	}

	setDisplayCategory(id) {
		const newCat = []
		for(const obj of this.state.category) {
			if (obj.classificationId === id) {
				newCat.push({
					"id": obj.categoryId,
					"name": obj.name,
				})
			}
		}
		this.setState({displayCategory: newCat, subClassification: "-- SELECT --"})
	}

	render() {
		let condition = null, is_on = null
		if(this.props.view === "update" || this.props.view === "view-details") {
			condition = (this.props.view === "update" || this.props.view === "view-details")
			is_on = (this.state.circumstance_id != null)? 1: 0
			if (this.state.sc === 'FEMALE') {document.getElementById('cell-circ').style.display = 'block' }
			if (this.state.circumstance_id!=null || this.state.circumstance_id!=undefined){
				document.getElementById('pi-circunstance').style.display = 'block'
			}
			if (this.props.view === "update" && (this.state.circumstance_id === null || this.state.circumstance_id === undefined)) {
				this.state.ruralWoman = "-- SELECT --"
			}
		} else {
			condition = this.state.farmerID == null
			is_on = 0
		}
		const view = <div className="personal-information">
			<div className="cell cell1">
				<div>
					<div className="cell1-dr">
						<div>* Date Registered</div>
						{this.state.dateRegistered != null && <DatePicker max={this.state.dateToday}
							name="date-registered"
							placeholder=""
							value={this.state.dateRegistered}
							onChange={(value) => {
								this.props.onValueChange("personal-info", "farmerRegistration", "registration_date", value)
							}}
						/>}
						{this.state.dateRegistered == null && <DatePicker max={this.state.dateToday}
							name="date-registered"
							onChange={(value) => {
								this.props.onValueChange("personal-info", "farmerRegistration", "registration_date", value)
							}}
						/>}
					</div>
					<div className="cell1-frn">
						<div>* Farmer Registration Number</div>
						<RegistrationNumber value={this.state.registrationNo} onChange={(v) => {
							let n = ""
							for(const m of v) {
								n += m
							}
							this.props.onValueChange("personal-info", "farmerRegistration", "registration_no", n)
							this.setState({registrationNo: v})
						}} />
					</div>
					<div className="cell1-rc" cStyle={{"width": "100%"}}>
						<div>* Registrant Classification</div>
						<DropdownWidget list={this.state.classifications} placeholder={this.state.classification}
							cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
								this.setDisplayCategory(parseInt(id))
								this.props.onValueChange("personal-info", "farmerRegistration", "classification_id", id)
								document.getElementById('arb-id').focus()
							}}
						/>
					</div>
					<div className="cell1-arbid" cStyle={{"width": "100%"}}>
						<div>ARB ID</div>
						<input type="text" id="arb-id" value={this.state.arbID} onChange={(e) => {
							this.props.onValueChange("personal-info", "farmerRegistration", "arb_id", e.target.value)
							this.setState({arbID: e.target.value})
						}} />
					</div>
					<div className="cell1-ac">
						<div>* Registrant Subclassification</div>
						<DropdownWidget list={this.state.displayCategory} placeholder={this.state.subClassification} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								this.state.onItemSelected("personal-info", id, val)
								document.getElementById('first-name').focus()
							}}
						/>
					</div>
				</div>
				<div>
					<div className="cell1-fn">
						<div style={{'margin-top': '20px'}}>* Full Name of Farmer/Registrant</div>
						<div className="cell1-fn1">
							<div >
								<input type="text" id="first-name" value={this.state.firstName} placeholder="FIRST NAME" onChange={(e) => {
									this.props.onValueChange("personal-info", "farmerBasicInfo", "first_name", e.target.value)
									this.setState({firstName: e.target.value})
								}} />
								<input type="text" id="middle-name" value={this.state.middleName} placeholder="MIDDLE NAME" onChange={(e) => {
									this.props.onValueChange("personal-info", "farmerBasicInfo", "middle_name", e.target.value)
									this.setState({middleName: e.target.value})
								}} />
								<input type="text" id="last-name" value={this.state.lastName} placeholder="LAST NAME" onChange={(e) => {
									this.props.onValueChange("personal-info", "farmerBasicInfo", "last_name", e.target.value)
									this.setState({lastName: e.target.value})
								}} />
								<span><DropdownWidget list={this.state.extName} placeholder={this.state.ext} cStyle={{"width": "70px"}}
									onItemSelected={(id, val) => {
										if (val === "N/A") {
											val = null
										}
										this.props.onValueChange("personal-info", "farmerBasicInfo", "extension_name", val)
									}} />
								</span>
							</div>
							<div id="cell-rsba">
								<SwitchWidget isOn={this.state.inRSBA} view={this.props.view} onToggle={(v) => {
									let inrsbalist = 1
									inrsbalist = (v === true)? inrsbalist:0
									this.props.onValueChange("personal-info", "farmerRegistration", "in_rsbsa_list", inrsbalist)
								}} />
								<span>In RSBSA List?</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="cell cell2">
				<div>
					<div className="cell2-dob">
						<div>* Date of Birth</div>
						<DatePicker name="birthday" max={this.state.dateToday}
							value={this.state.birthDate} onChange={(value) => {
							const bd = new Date(value)
							const now = new Date()
							let yAge = 0
							if (bd.getYear() < now.getYear()) {
								yAge = now.getYear() - bd.getYear()
								if (bd.getMonth() < now.getMonth()) {
									yAge = yAge
								} else if (bd.getMonth() === now.getMonth()) {
									if(bd.getDate() <= now.getDate()) {
										yAge = yAge
									} else yAge = yAge - 1
								} else yAge = yAge - 1
							} else yAge = 0
							this.setState({age: yAge})
							this.props.onValueChange("personal-info", "farmerBasicInfo", "birth_date", value)
						}} />
					</div>
					<div className="cell2-age">
						<div>Age</div>
						<div>{this.state.age} years old</div>
					</div>
					<div className="cell2-cs">
						<div>* Civil Status</div>
						<DropdownWidget list={this.state.civilStatus} placeholder={this.state.cs} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								this.props.onValueChange("personal-info", "farmerRegistration", "civil_status_id", id)
							}}
						/>
					</div>
				</div>
				<div>
					<div className="cell2-sex">
						<div>* Sex</div>
						<div><DropdownWidget list={this.state.sex} placeholder={this.state.sc} cStyle={{"width": "190px"}}
							onItemSelected={(id, val) => {
								if(id == 1) { //male
									document.getElementById('cell-circ').style.display = 'none'
									document.getElementById('pi-circunstance').style.display = 'none'
								}
								else {
									document.getElementById('cell-circ').style.display = 'block'
								}
								this.props.onValueChange("personal-info", "farmerBasicInfo", "sex_code", val.charAt(0))
							}}
						/></div>
						{{condition} && <div id="cell-circ">
							<SwitchWidget view={this.props.view} isOn={is_on} onToggle={(v) => {
								if(v) {
									document.getElementById('pi-circunstance').style.display = 'block'
								}
								else {
									document.getElementById('pi-circunstance').style.display = 'none'
								}
							}} />
							<span>With Special Circumstance</span>
						</div>}
						<div id="pi-circunstance"><DropdownWidget list={this.state.circumstances} placeholder={this.state.ruralWoman} cStyle={{"width": "190px"}}
							onItemSelected={(id, val) => {
								this.props.onValueChange("personal-info", "farmerRegistration", "rural_women_circumstance_id", id)
							}}
						/></div>
					</div>
					<div className="cell2-hea">
						<div>Highest Education Attainment</div>
						<DropdownWidget list={this.state.educationLevels} placeholder={this.state.educ} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								if(id != 0 && id != 6) {
									document.getElementById('graduate').style.display = 'block'
								}
								else {
									document.getElementById('graduate').style.display = 'none'
									this.props.onValueChange("personal-info", "farmerRegistration", "did_graduate", 0)
									document.getElementById('contact-no').focus()
								}
								this.props.onValueChange("personal-info", "farmerRegistration", "education_id", id)
							}}
						/>
						{this.props.farmerID != null && <div id="graduate" style={{display: 'block'}}>
							<div>Was able to graduate?</div>
							<DropdownWidget list={this.state.didGraduate} cStyle={{"width": "55%"}}
								placeholder={(this.state.didGrad == 1)? "YES": "NO"} 
								onItemSelected={(id, val) => {
									this.props.onValueChange("personal-info", "farmerRegistration", "did_graduate", id)
									document.getElementById('contact-no').focus()
								}}
							/>
						</div>}
						{this.props.farmerID == null && <div id="graduate">
							<div>Was able to graduate?</div>
							<DropdownWidget list={this.state.didGraduate}  placeholder="-- SELECT --" cStyle={{"width": "55%"}}
								onItemSelected={(id, val) => {
									this.props.onValueChange("personal-info", "farmerRegistration", "did_graduate", id)
									document.getElementById('contact-no').focus()
								}}
							/>
						</div>}
					</div>
					<div className="cell2-cn">
						<div>Contact Number</div>
						<input type="text" id="contact-no" value={this.state.contactNo} onChange={(e) => {
							const checker = /^[0-9]+$/
							const isValid = checker.test(e.target.value)
							if(isValid) {
								this.props.onValueChange("personal-info", "farmerRegistration", "contact_no", e.target.value)
							}
							else {
								if(isNaN(parseInt(e.target.value))) {
									this.setState({contactNo: null})
									e.target.value = ""
								}
								else {
									e.target.value = parseInt(e.target.value)
								}
							}
						}} maxLength="11" />
					</div>
				</div>
			</div>
			<div className="cell cell3">
				<div>Home Address</div>
				<DropdownWidget list={this.state.regions} placeholder={this.state.regionPlaceholder} cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
					this.getAllProvincesByRegionId(id, true)
					this.props.onValueChange("personal-info", "farmerHomeAddress", "region_id", id, val)
				}} />
				<DropdownWidget list={this.state.provinces} placeholder={this.state.provincePlaceholder} cStyle={{"width": "100%"}}  onItemSelected={(id, val) => {
					this.getAllCitiesByProvinceId(id, true)
					this.props.onValueChange("personal-info", "farmerHomeAddress", "province_id", id, val)
				}} />
				<DropdownWidget list={this.state.cities} placeholder={this.state.cityPlaceholder} cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
					this.getAllBarangaysByCityId(id, true)
					this.props.onValueChange("personal-info", "farmerHomeAddress", "city_id", id)
				}} />
				<DropdownWidget list={this.state.barangays} placeholder={this.state.brgyPlaceholder} cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
					this.props.onValueChange("personal-info", "farmerHomeAddress", "barangay_id", id)
				}} />
			</div>
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class RegistrationNumber extends Component
{
	constructor(props) {
		super(props)
		this.state = {regNum: []}
	}

	componentDidUpdate(prevProps) {
		if(prevProps.value != this.props.value && prevProps.value == null) {
			this.setState({
				regNum0: this.props.value[0],
				regNum1: this.props.value[1],
				regNum2: this.props.value[2],
				regNum3: this.props.value[3],
				regNum4: this.props.value[4],
				regNum5: this.props.value[5],
				regNum6: this.props.value[6],
				regNum7: this.props.value[7],
				regNum8: this.props.value[8],
				regNum9: this.props.value[9],
			})
		}
	}

	render() {
		if(this.props.value != null) {
			for(let i=0; i<this.props.value.length; i++) {
				this.state.regNum[i] = this.props.value[i]
			}
		}
		let view = <div className="reg-num">
		<input type="text" id="reg-num" value={this.state.regNum0}
			onChange={(e) => {
				if(setRegNum(e)) {
					this.state.regNum[0] = e.target.value
					this.props.onChange(this.state.regNum)
					this.setState({regNum0: e.target.value})
				}
			}}
			onFocus={(e) => {
				e.target.select()
			}}
			maxLength="1"
		/>
		<input type="text" value={this.state.regNum1}
			onChange={(e) => {
				if(setRegNum(e)) {
					this.state.regNum[1] = e.target.value
					this.props.onChange(this.state.regNum)
					this.setState({regNum1: e.target.value})
				}
			}}
			onFocus={(e) => {
				e.target.select()
			}}
			maxLength="1"
		/>
		<input type="text" value={this.state.regNum2}
			onChange={(e) => {
				if(setRegNum(e)) {
					this.state.regNum[2] = e.target.value
					this.props.onChange(this.state.regNum)
					this.setState({regNum2: e.target.value})
				}
			}}
			onFocus={(e) => {
				e.target.select()
			}}
			maxLength="1"
		/>
		<input type="text" value={this.state.regNum3}
			onChange={(e) => {
				if(setRegNum(e)) {
					this.state.regNum[3] = e.target.value
					this.props.onChange(this.state.regNum)
					this.setState({regNum3: e.target.value})
				}
			}}
			onFocus={(e) => {
				e.target.select()
			}}
			maxLength="1"
			style={{"margin-right": "15px"}}
		/>
		<input type="text" value={this.state.regNum4}
			onChange={(e) => {
				if(setRegNum(e)) {
					this.state.regNum[4] = e.target.value
					this.props.onChange(this.state.regNum)
					this.setState({regNum4: e.target.value})
				}
			}}
			onFocus={(e) => {
				e.target.select()
			}}
			maxLength="1"
		/>
		<input type="text" value={this.state.regNum5}
			onChange={(e) => {
				if(setRegNum(e)) {
					this.state.regNum[5] = e.target.value
					this.props.onChange(this.state.regNum)
					this.setState({regNum5: e.target.value})
				}
			}}
			onFocus={(e) => {
				e.target.select()
			}}
			maxLength="1"
		/>
		<input type="text" value={this.state.regNum6}
			onChange={(e) => {
				if(setRegNum(e)) {
					this.state.regNum[6] = e.target.value
					this.props.onChange(this.state.regNum)
					this.setState({regNum6: e.target.value})
				}
			}}
			onFocus={(e) => {
				e.target.select()
			}}
			maxLength="1"
		/>
		<input type="text" value={this.state.regNum7}
			onChange={(e) => {
				if(setRegNum(e)) {
					this.state.regNum[7] = e.target.value
					this.props.onChange(this.state.regNum)
					this.setState({regNum7: e.target.value})
				}
			}}
			onFocus={(e) => {
				e.target.select()
			}}
			maxLength="1"
		/>
		<input type="text" value={this.state.regNum8}
			onChange={(e) => {
				if(setRegNum(e)) {
					this.state.regNum[8] = e.target.value
					this.props.onChange(this.state.regNum)
					this.setState({regNum8: e.target.value})
				}
			}}
			onFocus={(e) => {
				e.target.select()
			}}
			maxLength="1"
		/>
		<input type="text" value={this.state.regNum9}
			onChange={(e) => {
				if(setRegNum(e, true)) {
					this.state.regNum[9] = e.target.value
					this.props.onChange(this.state.regNum)
					this.setState({regNum9: e.target.value})
				}
			}}
			onFocus={(e) => {
				e.target.select()
			}}
			maxLength="1"
		/></div>
		return(view)
	}
}

const setRegNum = (e, isLast) => {
	if(e.target.value === " ") {
		e.target.value = ""
		return(false)
	}
	if(isNaN(parseInt(e.target.value))) {
		e.target.value = ""
	}
	if(isLast) {
		return(true)
	}
	if(e.target.value.length === 1) {
		e.target.nextSibling.focus()
	}
	return(true)
}

export default PersonalInformation
